// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ik-3";
export var downloadButton = "_ik-4";
export var fileContainer = "_ik-9 _ik-7";
export var fileContainerBase = "_ik-7";
export var fileContainerFixedHeight = "_ik-8 _ik-7";
export var fileInfo = "_ik-5";
export var fileInfoWidthRestricted = "_ik-6";
export var fileType = "_ik-1";
export var fileTypeName = "_ik-2";
export var image = "_ik-0";
export var link = "_ik-b";
export var overflowEllipsis = "_ik-a";